import {
    RECAPTCHA_SETTINGS,
    RecaptchaSettings,
    RECAPTCHA_LANGUAGE
  } from "ng-recaptcha";
import { ArticlesSiteService } from "./services/articlesSite.service";
import { BlogsSiteService } from "./services/blogsSiteService";
import { ColleaguesSiteService } from "./services/colleaguesSite.service";
import { DesignedWebSitesSiteService } from "./services/designedWebSitesSite.service";
import { DynamicPagesSiteService } from "./services/dynamicPagesSite.service";
import { FAQsSiteService } from "./services/fAQsSite.service";
import { GalleryGroupsSiteService } from "./services/galleryGroupsSite.service";
import { VideosSiteService } from "./services/videosSite.service";
import { ProductTypesSiteService } from "./services/productTypesSite.service";
import { GalleryImagesSiteService } from "./services/galleryImagesSite.service";
import { ProductCustomersSiteService } from "./services/productCustomersSite.service";
import { ProductImagesSiteService } from "./services/productImagesSite.service";
import { ProductSpecificationsSiteService } from "./services/productSpecificationsSite.service";
import { StaticPagesSiteService } from "./services/staticPagesSite.service";
import { ProductsSiteService } from "./services/productsSite.service";
import { SiteSEOHelperService } from "./services/siteseoHelper.service";
import { SuggestionsSiteService } from "./services/suggestionsSite.service";
import { RepairRequestService } from "./services/repair-request.service";
import { MarakezService } from "./services/marakez.service";
import { PermitsSiteService } from "./services/permitsSite.service";

export const appProviders = [
  {
    provide: RECAPTCHA_SETTINGS,
    useValue: {
      siteKey: "6Le3xrsUAAAAAAHi1EKWxdVMlSu2zkHt9GIhWoRa"
    } as RecaptchaSettings
  },
  {
    provide: RECAPTCHA_LANGUAGE,
    useValue: "fa"
  },
  ArticlesSiteService,
  BlogsSiteService,
  ColleaguesSiteService,
  DesignedWebSitesSiteService,
  DynamicPagesSiteService,
  FAQsSiteService,
  GalleryGroupsSiteService,
  VideosSiteService,
  ProductTypesSiteService,
  GalleryImagesSiteService,
  ProductCustomersSiteService,
  ProductImagesSiteService,
  ProductSpecificationsSiteService,
  StaticPagesSiteService,
  ProductsSiteService,
  SuggestionsSiteService,
  SiteSEOHelperService,
  RepairRequestService,
  MarakezService,
  PermitsSiteService
];
